var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "new-journal"
  }, [_c('HeaderNewCopy'), _c('div', {
    staticClass: "pc landing-invest"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-info"
  }, [_vm._m(0), _c('p', {
    staticClass: "text"
  }, [_vm._v(" Получите доступ к самой актуальной и проверенной информации")]), _c('form', {
    staticClass: "enter-form-invest",
    attrs: {
      "autocomplete": "_off"
    }
  }, [_c('div', {
    staticClass: "input-containers",
    class: {
      'input-containers-error': _vm.response.type === 'error',
      'input-containers-success': _vm.response.type === 'success'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.phone,
      expression: "phone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: '+7 ### ### ## ##',
      expression: "'+7 ### ### ## ##'"
    }],
    staticClass: "text-input",
    attrs: {
      "type": "tel",
      "placeholder": "+7 999 123 45 67"
    },
    domProps: {
      "value": _vm.phone
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value;
      }
    }
  }), _c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": "Получить доступ"
    },
    on: {
      "buttonAction": _vm.handleSubmit
    }
  })], 1)])]), _vm._m(1)]), _vm._m(2), _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "banner-info"
  }, [_vm._m(3), _c('form', {
    staticClass: "enter-form-invest",
    attrs: {
      "autocomplete": "_off"
    }
  }, [_c('div', {
    staticClass: "input-containers",
    class: {
      'input-containers-error': _vm.response.type === 'error',
      'input-containers-success': _vm.response.type === 'success'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.phone,
      expression: "phone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: '+7 ### ### ## ##',
      expression: "'+7 ### ### ## ##'"
    }],
    staticClass: "text-input",
    class: {
      'input-success': _vm.phone.length === 16
    },
    attrs: {
      "type": "tel",
      "placeholder": "+7 999 123 45 67"
    },
    domProps: {
      "value": _vm.phone
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value;
      }
    }
  }), _c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": "Получить доступ"
    },
    on: {
      "buttonAction": _vm.handleSubmit
    }
  })], 1)])]), _c('div', {
    staticClass: "banner-img"
  })])]), _c('div', {
    staticClass: "phone landing-invest"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-info"
  }, [_vm._m(4), _vm._m(5), _c('form', {
    staticClass: "enter-form-invest",
    attrs: {
      "autocomplete": "_off"
    }
  }, [_c('div', {
    staticClass: "input-containers",
    class: {
      'input-containers-error': _vm.response.type === 'error',
      'input-containers-success': _vm.response.type === 'success'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.phone,
      expression: "phone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: '+7 ### ### ## ##',
      expression: "'+7 ### ### ## ##'"
    }],
    staticClass: "text-input",
    attrs: {
      "type": "tel",
      "placeholder": "+7 999 123 45 67"
    },
    domProps: {
      "value": _vm.phone
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value;
      }
    }
  }), _c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": "Получить доступ"
    },
    on: {
      "buttonAction": _vm.handleSubmit
    }
  })], 1)])]), _c('div', {
    staticClass: "img-invest"
  })]), _vm._m(6), _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "banner-info"
  }, [_vm._m(7), _c('form', {
    staticClass: "enter-form-invest",
    attrs: {
      "autocomplete": "_off"
    }
  }, [_c('div', {
    staticClass: "input-containers",
    class: {
      'input-containers-error': _vm.response.type === 'error',
      'input-containers-success': _vm.response.type === 'success'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.phone,
      expression: "phone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: '+7 ### ### ## ##',
      expression: "'+7 ### ### ## ##'"
    }],
    staticClass: "text-input",
    attrs: {
      "type": "tel",
      "placeholder": "+7 999 123 45 67"
    },
    domProps: {
      "value": _vm.phone
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value;
      }
    }
  }), _c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": "Получить доступ"
    },
    on: {
      "buttonAction": _vm.handleSubmit
    }
  })], 1)])]), _c('div', {
    staticClass: "banner-img"
  })])]), _c('FooterAgreement', {
    on: {
      "setAgree": _vm.isAgree
    }
  }), _vm._m(8)], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h1', {
    staticClass: "title"
  }, [_vm._v("Откройте "), _c('br'), _vm._v("мир инвестиций по-новому вместе с Финсайт")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "img-background"
  }, [_c('div', {
    staticClass: "img-invest"
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "products"
  }, [_c('h2', {
    staticClass: "sub-title"
  }, [_vm._v("Наши специалисты ежедневно изучают события, "), _c('br'), _vm._v(" влияющие на фондовые рынки, и делятся ими с вами")]), _c('div', {
    staticClass: "product_cards"
  }, [_c('div', {
    staticClass: "product_card"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/landing-invest-news.svg"),
      "alt": "news"
    }
  }), _c('h4', {
    staticClass: "title"
  }, [_vm._v("Новости")]), _c('p', {
    staticClass: "text"
  }, [_vm._v("Узнавайте первыми о значимых событиях для фондового рынка")])]), _c('div', {
    staticClass: "product_card"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/landing-invest-reviews.svg"),
      "alt": "reviews"
    }
  }), _c('h4', {
    staticClass: "title"
  }, [_vm._v("Обзоры")]), _c('p', {
    staticClass: "text"
  }, [_vm._v("Исследуйте интересные активы и прогнозы их поведения")])]), _c('div', {
    staticClass: "product_card"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/landing-invest-ideas.svg"),
      "alt": "ideas"
    }
  }), _c('h4', {
    staticClass: "title"
  }, [_vm._v("Идеи")]), _c('p', {
    staticClass: "text"
  }, [_vm._v("Берите на вооружение мысли опытных инвесторов")])]), _c('div', {
    staticClass: "product_card"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/landing-invest-strategies.svg"),
      "alt": "strategies"
    }
  }), _c('h4', {
    staticClass: "title"
  }, [_vm._v("Стратегии")]), _c('p', {
    staticClass: "text"
  }, [_vm._v("Применяйте различные техники управления вложениями")])])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h2', {
    staticClass: "sub-title"
  }, [_vm._v("Получайте ценные сведения и принимайте "), _c('br'), _vm._v(" взвешенные решения, как и куда вложить свои средства "), _c('img', {
    attrs: {
      "src": require("@/assets/img/landing-invest-banner-mark.svg"),
      "alt": "mark"
    }
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h1', {
    staticClass: "title"
  }, [_vm._v("Откройте "), _c('br'), _vm._v("мир инвестиций "), _c('br'), _vm._v("по-новому вместе "), _c('br'), _vm._v(" с Финсайт")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "text"
  }, [_vm._v(" Получите доступ к самой актуальной "), _c('br'), _vm._v("и проверенной информации")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "products"
  }, [_c('h2', {
    staticClass: "sub-title"
  }, [_vm._v("Наши специалисты ежедневно изучают события, влияющие "), _c('br'), _vm._v("на фондовые рынки, и делятся ими с вами")]), _c('div', {
    staticClass: "product_cards"
  }, [_c('div', {
    staticClass: "product_card"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/landing-invest-news.svg"),
      "alt": "news"
    }
  }), _c('h4', {
    staticClass: "title"
  }, [_vm._v("Новости")]), _c('p', {
    staticClass: "text"
  }, [_vm._v("Узнавайте первыми о значимых событиях для фондового рынка")])]), _c('div', {
    staticClass: "product_card"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/landing-invest-reviews.svg"),
      "alt": "reviews"
    }
  }), _c('h4', {
    staticClass: "title"
  }, [_vm._v("Обзоры")]), _c('p', {
    staticClass: "text"
  }, [_vm._v("Исследуйте интересные активы "), _c('br'), _vm._v("и прогнозы их поведения")])]), _c('div', {
    staticClass: "product_card"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/landing-invest-ideas.svg"),
      "alt": "ideas"
    }
  }), _c('h4', {
    staticClass: "title"
  }, [_vm._v("Идеи")]), _c('p', {
    staticClass: "text"
  }, [_vm._v("Берите на вооружение мысли опытных инвесторов")])]), _c('div', {
    staticClass: "product_card"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/landing-invest-strategies.svg"),
      "alt": "strategies"
    }
  }), _c('h4', {
    staticClass: "title"
  }, [_vm._v("Стратегии")]), _c('p', {
    staticClass: "text"
  }, [_vm._v("Применяйте различные техники управления вложениями")])])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h2', {
    staticClass: "sub-title"
  }, [_vm._v("Получайте ценные сведения"), _c('br'), _vm._v("и принимайте "), _c('br'), _vm._v(" взвешенные решения, как"), _c('br'), _vm._v(" и куда вложить свои средства "), _c('img', {
    attrs: {
      "src": require("@/assets/img/landing-invest-banner-mark.svg"),
      "alt": "mark"
    }
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "notpersonal-advice"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/landing-invest-banner-mark-mini.svg"),
      "alt": "mark"
    }
  }), _c('p', [_vm._v("Любые сведения, указанные в Статьях, носят исключительно рекомендательный характер и нацелены на оказание помощи Пользователям Сервиса в получении необходимой справочной информации. Администрация Сервиса не несет ответственности за убыток или ущерб, включая, в частности, любую утрату выгоды, которая может являться прямым или косвенным результатом использования или принятия во внимание такой информации. Не является индивидуальной инвестиционной рекомендацией.")])]);
}]

export { render, staticRenderFns }